import Menu from './classes/Menu.js';
import SaveNotes from './classes/SaveNotes.js';
import UpdateStatus from './classes/UpdateStatus.js';
import Form from './classes/Form.js';
import SwiperBlock from './classes/Swiper.js';
import Countdown from './classes/Countdown.js';
import CopyClipboard from './classes/CopyClipboard.js';
import DataTables from './classes/DataTables.js';
import Modal from './classes/Modal.js';
import Scroll from './classes/Scroll.js';

import Init from './classes/Init';


const siteFunctions = {
  documentReady__ready() {
  },

  menu__ready() {
    const menu = new Menu();
    menu.init();
  },
  
  saveNotes__ready() {
    const saveNotes = new SaveNotes();
    saveNotes.init();
  },

  updateStatus__ready() {
    const updateStatus = new UpdateStatus();
    updateStatus.init();
  },

  form__ready() {
    const form = new Form();
    form.init();
  },

  swiperBlock__ready() {
    const swiperBlock = new SwiperBlock();
    swiperBlock.init();
  },

  countdown__ready() {
    const countdown = new Countdown();
    countdown.init();
  },

  copyClipboard__ready() {
    const copyClipboard = new CopyClipboard();
    copyClipboard.init();
  },

  dataTables__ready() {
    const dataTables = new DataTables();
    dataTables.init();
  },

  modal__ready() {
    const modal = new Modal();
    modal.init();
  },

  scroll__ready() {
    const scroll = new Scroll();
    scroll.init();
  },

};

window.functionCore = new Init(siteFunctions);
